import type { SectionProps } from "../context";
import { field } from "../context";
import { Icon } from "../icons";
import { Container, Eyebrow, MultiLine, Ornament, REVEAL, SectionShell, cx } from "../ui";

/** One standout passage: a verse, a founder's promise, a guiding principle. */
export function Quote({ node, ctx }: SectionProps<"quote">) {
  const c = node.content;
  const ornate = node.variant === "ornate";
  return (
    <SectionShell ctx={ctx} node={node} labelledBy={false} className="relative isolate overflow-hidden">
      {ornate ? <div aria-hidden="true" className="baze-dots pointer-events-none absolute inset-0 -z-10 text-site-primary opacity-40 [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" /> : null}
      <Container size="narrow" className="text-center">
        <figure className={cx(REVEAL, ornate && "rounded-site-lg border border-site-border bg-site-surface/80 px-6 py-12 shadow-site-sm backdrop-blur-sm @3xl:px-14 @3xl:py-16")}>
          {ornate ? <Ornament className="mx-auto mb-8" /> : <Icon name="quote" className="mx-auto mb-6 size-12 text-site-primary/25" />}
          <Eyebrow ctx={ctx} text={c.eyebrow} path="content.eyebrow" className="mb-5" />
          <blockquote {...field(ctx, "content.text")}>
            <MultiLine
              ctx={ctx}
              text={c.text}
              className={cx("baze-heading leading-snug text-balance text-site-text", ornate ? "text-xl @3xl:text-[1.75rem]" : "text-2xl @3xl:text-[2.125rem]")}
              paragraphClassName="text-balance"
            />
          </blockquote>
          {c.cite ? (
            <figcaption className="mt-7 text-sm font-semibold tracking-[0.14em] text-site-primary uppercase" {...field(ctx, "content.cite")}>
              {ornate ? c.cite : `— ${c.cite}`}
            </figcaption>
          ) : null}
          {ornate ? <Ornament className="mx-auto mt-8 rotate-180" /> : null}
        </figure>
      </Container>
    </SectionShell>
  );
}
